import { Check } from 'lucide-react';
import { IMAGES, OFFICE_FEATURES, OFFICE_IDEAL } from '../mock';

export default function Offices() {
  return (
    <section id="offices" className="bg-[#f1ede5] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="relative">
              <img src={IMAGES.office} alt="Modern office suite" className="w-full h-[520px] object-cover" />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 border border-[#b39352] hidden md:block" />
            </div>
            <div className="mt-6 text-[10px] tracking-[0.25em] text-[#0d281e]/60">
              SUITE INTERIOR · CONTEMPORARY FINISHES
            </div>
          </div>

          <div>
            <span className="eyebrow">Office Suites</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              A premium working<br />
              <em className="text-[#b39352] italic">environment.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-lg">
              Eight modern office suites designed for professional businesses that want to impress
              clients and inspire teams.
            </p>

            <div className="mt-10">
              <span className="eyebrow">Features Include</span>
              <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-8">
                {OFFICE_FEATURES.map((f) => (
                  <div key={f} className="flex items-center gap-3 text-[14px]">
                    <Check size={16} className="text-[#b39352]" strokeWidth={2.5} />
                    {f}
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-12">
              <span className="eyebrow">Ideal for</span>
              <div className="mt-6 flex flex-wrap gap-2">
                {OFFICE_IDEAL.map((i) => (
                  <span
                    key={i}
                    className="text-[10px] tracking-[0.18em] uppercase px-4 py-2 border border-[#0d281e]/25 text-[#0d281e] hover:border-[#b39352] hover:text-[#b39352] transition-colors cursor-default"
                  >
                    {i}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
